import { createFileRoute } from '@tanstack/react-router';

import { LegalNoticePage } from '@/features/legal/routes/LegalNoticePage';

export const Route = createFileRoute('/legal')({
  component: LegalNoticePage,
});
